<div class="cell-container" (click)="startEdit()">
  <span class="text">
    {{ value }}
  </span>
  <span class="icon-wrapper">
    <nz-spin *ngIf="saving" nzSize="small"></nz-spin>
    <span *ngIf="!saving" class="edit-icon">
      <span nz-icon nzType="edit"></span>
    </span>
  </span>
</div>
